import React from 'react';
import BreadCrumbNav from './BreadCrumbNav';
import Footer from './Footer';
import MainHeader from './MainHeader';
import MobileMenu from './MobileMenu';
import ScrollToTopButton from './ScrollToTopButton';
import SearchPopup from './SearchPopup';
import ContactDetails from './ContactDetails';
import PreLoader from './PreLoader';

const Contact = () => {

  return (
    <div className="boxed_wrapper">
        {/* <PreLoader /> */}
        <SearchPopup />
        <MainHeader />
        <MobileMenu />
        <BreadCrumbNav title="Contact" />

        <ContactDetails />

        <Footer />
        <ScrollToTopButton />
    </div>
    );
  }
  
  export default Contact;